export default "__VITE_ASSET__e096d843__"